import { action } from 'satcheljs/lib/legacy';
import type {
    default as FilePickerViewState,
    FilePickerBreadcrumb,
} from '../store/schema/FilePickerViewState';

export default action('popFilePickerBreadcrumbsTill')(
    /*
        Pops the file picker breadcrumbs till the breadcrumb which is passed in, including it.
        If its the first breadcrumb then it is not popped but all others after it is popped,
        this is done so that the provider breadcrumb is not deleted (which is the first breadcrumb).
     */
    function popFilePickerBreadcrumbsTill(
        breadcrumb: FilePickerBreadcrumb,
        viewState: FilePickerViewState
    ) {
        const indexOfBreadcrumb = viewState.breadcrumbs.indexOf(breadcrumb);

        if (indexOfBreadcrumb >= 0) {
            const isFirstBreadcrumb = indexOfBreadcrumb === 0;
            const numberOfBreadcrumbsToPop = viewState.breadcrumbs.length - indexOfBreadcrumb;
            viewState.breadcrumbs.splice(
                isFirstBreadcrumb ? 1 : indexOfBreadcrumb, // If first breadcrumb then delete all after that
                isFirstBreadcrumb ? numberOfBreadcrumbsToPop - 1 : numberOfBreadcrumbsToPop
            );
        }
    }
);
